import { ImageGifMakerTool } from '@/features/image-gif-maker'

export function ImageGifMakerPage() {
  return <ImageGifMakerTool />
}
